import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';

import CustomersApi from '../services/api/customer.js';

export default {
    mixins: [pageLoadingStatusMixin],
    computed: {
        ...mapGetters({
            currentCustomer: 'user/currentCustomer',
            customers: 'customers/items',
            userCan: 'user/can'
        }),
        /**
         * Return if the customer has a whitelabel environment.
         *
         * @return {boolean}
         */
        canGiveWhitelabelAccess() {
            return this.currentCustomer && this.currentCustomer.availableActions.includes('canGiveWhitelabelAccess');
        },
        /**
         * Return the customers with a label and value.
         *
         * @return {array}
         */
        customerValues() {
            if (!this.customers) {
                return;
            }

            return Object.entries(this.customers).map(customer => {
                let customerParts = [];

                if (customer[1].organization) {
                    customerParts.push(customer[1].organization);
                }

                customerParts.push(customer[1].full_name);

                return {
                    id: customer[1].id,
                    name: customerParts.join(' - ')
                };
            });
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getCustomers();
    },
    methods: {
        /**
         * Get the customers, for the partner.
         */
        getCustomers() {
            if (this.currentCustomer && this.currentCustomer.availableActions.includes('list')) {
                CustomersApi.get().then(this.finishLoading);
            }
        }
    }
};
